import type { EmailSidebarSelectionStored, EmailSpecialView } from './emailSidebarSelectionStorage';

const STORAGE_KEY = 'ums-email-list-return-v1';
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

/** Saved list pagination so the selected row is still on screen after compose/detail. */
export type EmailListPaginationSnapshot = {
  currentPage: number;
  itemsPerPage: number;
  cursorByPage: Record<number, string>;
};

export type EmailListReturnContext = {
  search: string;
  sidebarSelection: EmailSidebarSelectionStored | null;
  restoreSelectedEmailId?: number | null;
  restorePartitionAt?: string | null;
  restoreSpecialView?: EmailSpecialView | null;
  mentionsViewActive?: boolean;
  restoreListPagination?: EmailListPaginationSnapshot | null;
  savedAt: number;
};

export function saveEmailListReturnContext(
  ctx: Omit<EmailListReturnContext, 'savedAt'>,
): void {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...ctx, savedAt: Date.now() } satisfies EmailListReturnContext),
    );
  } catch {
    /**/
  }
}

export function loadEmailListReturnContext(): EmailListReturnContext | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as EmailListReturnContext;
    if (!parsed || typeof parsed !== 'object') return null;
    if (typeof parsed.savedAt !== 'number' || Date.now() - parsed.savedAt > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearEmailListReturnContext(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /**/
  }
}
